module.exports = __webpack_public_path__ + "img/vue1-corpsavant_vert.f8ddad23.png";